import { Link } from "react-router-dom";
import { ArrowRight, Camera } from "lucide-react";
import { Heart, Squiggle } from "./Illustrations";
import { rooms } from "../data/rooms";

export default function RoomsPreview() {
  const previews = rooms.map((r) => ({ name: r.name, img: r.photos[0], color: r.color })).slice(0, 4);
  return (
    <section data-testid="rooms-preview-section" className="py-20 bg-brand-bg relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-white border-2 border-brand-secondary mb-5 -rotate-1">
            <Camera size={18} className="text-brand-primary" />
            <span className="font-body text-sm font-bold text-brand-text">Οι Χώροι μας</span>
          </div>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl text-brand-text">
            Ελάτε να γνωρίσετε{" "}
            <span className="font-hand text-4xl sm:text-5xl text-brand-primary">τους χώρους μας</span>
          </h2>
          <Squiggle className="mx-auto my-4" width={160} color="#B8D6BE" />
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {previews.map((p, i) => (
            <Link key={i} to="/oi-choroi-mas" data-testid={`rooms-preview-card-${i}`} className={`group rounded-[1.5rem] overflow-hidden border-3 border-dashed ${p.color} bg-white ${i % 2 ? "rotate-1" : "-rotate-1"} hover:rotate-0 hover:scale-[1.03] transition-transform duration-500 shadow-[0_6px_0_-2px_rgba(91,79,70,0.15)]`}>
              <img src={p.img} alt={p.name} loading="lazy" decoding="async" className="w-full h-40 md:h-48 object-cover" />
              <div className="p-3 font-heading font-bold text-sm text-brand-text text-center">{p.name}</div>
            </Link>
          ))}
        </div>
        <div className="text-center mt-8">
          <Link to="/oi-choroi-mas" data-testid="rooms-preview-link" className="inline-flex items-center gap-2 font-heading font-bold text-brand-primaryHover hover:gap-3 transition-all">
            Δείτε όλους τους χώρους μας <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    </section>
  );
}
